export default __webpack_public_path__ + "static/media/fill-1-hover.65299035.svg";